import Memory from './Handler/Memory';

export const CACHE_TIME_15_MIN = 900000;
export const CACHE_TIME_1_HOUR = 3600000;
export const CACHE_TIME_4_HOUR = 14400000;

export default class Cache {

    constructor() {
        this.handler = new Memory; 
    }

    setItem(key, value, ttl) {
        return this.handler.setItem(key, value, ttl);
    }

    getItem(key) {
        return this.handler.getItem(key);
    }

}